import { CHANNELS } from 'constants/Channels';
import ufeApi from 'services/api/ufeApi';

/**
 * Fetches subscription details for a replenishment subscription.
 *
 * @param {Object} params - Request parameters.
 * @param {string} params.subscriptionId - The subscription identifier to fetch.
 * @returns {Promise<Object>} A promise that resolves with the subscription response data.
 * @throws {Object} Throws the API response object when the request returns errors or a failure status.
 */
async function getSubscription({ subscriptionId }) {
    const { sdnUfeAPIUserKey } = Sephora.configurationSettings;
    const { country, language } = Sephora.renderQueryParams;
    const url = `/gway/v1/replenishment/${subscriptionId}?includeProductInfo=true&apikey=${sdnUfeAPIUserKey}`;

    const options = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Site-Locale': country,
            'Site-Language': language,
            'x-requested-source': CHANNELS.RWD
        }
    };

    const data = await ufeApi.makeRequest(url, options);

    if (data.errors || data?.responseStatus >= 400) {
        throw data;
    }

    return data;
}

export default getSubscription;
